import script from "./ScoreChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreChart.vue?vue&type=script&setup=true&lang=js"

import "./ScoreChart.vue?vue&type=style&index=0&id=2018f3bd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2018f3bd"]])

export default __exports__